import { useEffect, useState } from "react";
import { Ticket } from "../../../models/Ticket";
import { get } from "../../../api";
import { GET_USER_SELECTS_URL } from "../../../api/apiRoutes";
import useFacility from "../../../../utils/hooks/useFacility";
import { calculateRemainingEntrances, isOpenPass } from "../../../utils/TicketPassHelper";

export default function useCourtPasses() {
  const facilityIds = useFacility();
  const [loading, setLoading] = useState(false);
  const [availablePasses, setAvailablePasses] = useState<Ticket[]>([]);

  const getAvailablePasses = async () => {
    setLoading(true);
    const { result, isError } = await get(GET_USER_SELECTS_URL(facilityIds));
    if (!isError) {
      setAvailablePasses(result);
    }
    setLoading(false);
  };

  // Filtrowanie karnetów dostępnych do zapisywania (nie bilety)
  const getFilteredPasses = (exerciseStartTime: number) => {
    return availablePasses.filter((item) => {
      const hasRemainingEntrances = isOpenPass(item.passtype) || calculateRemainingEntrances(item) > 0;

      return (
        item.ticket === false &&
        item.validfrom <= exerciseStartTime &&
        exerciseStartTime <= item.validto &&
        hasRemainingEntrances
      );
    });
  };

  useEffect(() => {
    if (facilityIds) {
      getAvailablePasses();
    }
    //eslint-disable-next-line
  }, [facilityIds]);

  return {
    loading,
    availablePasses,
    getFilteredPasses,
    refetchPasses: getAvailablePasses,
  };
}
